<template>
  <div>
    <div class="wBh_hh_PhoneLayer">
      <div class="gs_GuaranteeLayer" style="margin-top: -325px;height: 657px;">
        <span class="wBh_Close">
          <img src="@/assets/bh_close.png" />
        </span>
        <h5 class="gs_GuaranteeLayer_Title">关于兰州银行</h5>
        <div class="gs_Guarantee_Wrap clear">
          <!--第一页                 **************          开始-->
          <div class="gs_GuaranteeMain3 gs_GuaranteeMain_Active">
            <h3 class="gs_GuaranteeTitle"><i></i>关于兰州银行</h3>
            <h5 class="gs_GuaranteeTitleBto hh__GuaranteeTitleBto">
              1.
              1997年6月29日，经中国人民银行批准，在原兰州市56家城市信用社基础上，通过股份制改造和资产重组，地方财政、企业法人和自然人入股共同发起设立了兰州城市合作银行。这是甘肃省第一家地方法人股份制商业银行。1998年5月18日，更名为兰州市商业银行，2008年6月18日更名为兰州银行。全行现有员工4000余人，分行14家，营业网点176家，控股1家金融租赁公司，参股6家村镇银行。
            </h5>
            <h5 class="gs_GuaranteeTitleBto hh__GuaranteeTitleBto">
              2.
              2012年以来，兰州银行在中国银监会的监管评级一直为二类，是西北地区唯一一家连续六年被评为二类行的城商行。在2019年英国《银行家》杂志“全球银行1000强”排行榜中，兰州银行按一级资本排名位列第362位，按总资产排名位列第349位。在中国银行业协会发布的“2018中国银行业100强榜单”中，兰州银行位列57位。
            </h5>
            <h3 class="gs_GuaranteeTitle hh_GuaranteeTowTitle">
              <i></i>兰州银行优势
            </h3>
            <h5 class="gs_GuaranteeTitleBto hh__GuaranteeTitleBto">
              1. 银行信用担保，社会信用度高；
            </h5>
            <h5 class="gs_GuaranteeTitleBto hh__GuaranteeTitleBto">
              2. 手续费率低，支持扫码验真；
            </h5>
            <h5 class="gs_GuaranteeTitleBto hh__GuaranteeTitleBto">
              3. 在线申请，快速出函。
            </h5>
            <h3 class="gs_GuaranteeTitle hh_GuaranteeTowTitle">
              <i></i> 保函如何查验
            </h3>
            <h5 class="gs_GuaranteeTitleBto hh__GuaranteeTitleBto">
              扫描保函文本右上方二位码即可检验真伪。
            </h5>
            <!-- <ol class="gs_GuaranteeList hh_GuaranteeList clear">
              <li>
                <img src="@/assets/guarantee3.png" />
                <h3>成本低</h3>
                <h6>
                  <p>保函费用低廉</p>
                  <p>不占企业资金</p>
                </h6>
              </li>
              <li>
                <img src="@/assets/guarantee2.png" />
                <h3>效率高</h3>
                <h6>
                  <p>全程在线操作</p>
                  <p>系统自动签发</p>
                </h6>
              </li>

              <li>
                <img src="@/assets/xinyonghao.png" />
                <h3>信用好</h3>
                <h6>
                  <p>平台无缝对接</p>
                  <p>投标安全保障</p>
                </h6>
              </li>
            </ol>-->
          </div>
          <!--第一页                 **************          结束-->

          <!--第一页                 **************          开始-->
          <div class="gs_GuaranteeMain3">
            <h3 class="gs_GuaranteeTitle hh_GuaranteeTowTitle">
              <i></i> 企业违约赔付流程
            </h3>
            <h5 class="gs_GuaranteeTitleBto hh__GuaranteeTitleBto">
              保函申请人在我行开具保函的有效期限内未能履行合同义务，经办行在接到受益人的书面追索申请后，对其追索申请的内容进行审查，对符合保函项下条件的，向受益人履行支付或赔偿的责任，并根据出具保函协议的约定，从保函申请人的保证金帐户和其他存款帐户扣款用于向受益人支付的资金，不足部分由银行垫付。
            </h5>
            <h3 class="gs_GuaranteeTitle"><i></i>用户常见问题解答 ?</h3>
            <div class="wBh_QuestionWrap hh_QuestionWrap">
              <dl
                class="wBh_Question clear"
                style="    padding-top: 6px !important;"
              >
                <dd>Q:投标保函出函时效?</dd>
                <dt>
                  A:
                  在线提交申请后当天即可出函，如果您使用CA登录申请，则可实时出函。保函文本可在申请审批通过后在线下载。
                </dt>
              </dl>
              <dl class="wBh_Question clear">
                <dd>Q：保函有效期？</dd>
                <dt>
                  A：自保函出具之日起至招标文件规定的投标有效期届满后30日。投标有效期延长的，本保函有效期相应顺延，但最长不超过一年。
                </dt>
              </dl>
              <dl class="wBh_Question clear">
                <dd>Q: 保函收费？</dd>
                <dt>A：按保函金额的6‰收取，单笔最低200元。</dt>
              </dl>
              <dl class="wBh_Question clear">
                <dd>Q：是否可以开票？</dd>
                <dt>
                  A：可以根据客户需求开具普票或专票，开票电话：19100155931、0791-86806097。
                </dt>
              </dl>
              <dl class="wBh_Question clear">
                <dd>Q: 是否需要提供抵押？</dd>
                <dt>A：无需抵押，在线填写申请信息，支付保函费用即可出函。</dt>
              </dl>
            </div>
          </div>
          <!--第一页                 **************          结束-->
        </div>
        <!--分页                 **************          开始-->
        <div class="gs_GuaranteePage clear">
          <ol class="clear">
            <li class="gs_PageBtn gs_PageLeft">
              <span>
                <img src="@/assets/pageLeft.png" />
              </span>
            </li>
            <ul class="pageNumWrap3 clear">
              <li class="pageNum active">
                <span>1</span>
              </li>
              <li class="pageNum">
                <span>2</span>
              </li>
            </ul>
            <li class="gs_PageBtn gs_PageRight">
              <span>
                <img src="@/assets/pageRight.png" />
              </span>
            </li>
          </ol>
        </div>
        <!--分页                 **************          结束-->
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

import "@/assets/css/about_danbao.css";

export default {
  name: "register",
  data() {
    return {};
  },
  mounted() {
    var that = this;
    var $li = $(".pageNumWrap3 li");
    var len = $li.length - 1;
    var _index = 0; //li的索引
    var $img = $(".gs_GuaranteeMain3");
    play();
    //点击事件
    $li.click(function() {
      _index = $(this).index();
      play();
    });

    function play() {
      //获取li的下标，改变样式
      $li
        .eq(_index)
        .addClass("active")
        .siblings()
        .removeClass("active");
      //获取图片的下标，实现淡入淡出
      $img
        .eq(_index)
        .slideDown()
        .siblings()
        .slideUp();
    }

    //两边耳朵的点击事件
    $(".gs_PageBtn").click(function() {
      var index = $(this).index();
      if (index) {
        _index++;
        if (_index > len) {
          _index = 0;
        }
        play();
      } else {
        _index--;
        if (_index < 0) {
          _index = len;
        }
        play();
      }
    });
    layui.use(
      ["jquery", "element", "step", "form", "laydate", "layer", "table"],
      function() {
        var $ = layui.jquery,
          form = layui.form,
          step = layui.step,
          element = layui.element,
          table = layui.table,
          layer = layui.layer,
          laydate = layui.laydate;
      }
    );
  },
  beforeCreate() {
    // console.group('beforeCreate 创建前状态===============》');
  },
  created() {
    // loadingInstance.close();
  }
};
</script>

<style></style>
